import React from "react";

const EmployeeSelector = ({ count, setCount, t }) => {
  const handleChange = (value) => {
    if (value < 1) return;
    setCount(value);
  };

  return (
    <div className="mb-6 text-center">
      <p className="mb-4 text-gray-500">
        {t("pricing.calculator.employeesLabel")}
      </p>

      <div className="flex items-center justify-center gap-2">
        <button
          onClick={() => handleChange(count - 1)}
          className="rounded-md border px-3 py-1"
        >
          -
        </button>

        <input
          type="number"
          value={count}
          onChange={(e) => handleChange(Number(e.target.value))}
          className="w-24 rounded-md border py-1 text-center"
          placeholder={t("pricing.calculator.employeesPlaceholder")}
        />

        <button
          onClick={() => handleChange(count + 1)}
          className="rounded-md border px-3 py-1"
        >
          +
        </button>
      </div>

      <p className="mt-2 text-xs text-gray-400">
        {t("pricing.calculator.dynamicNote")}
      </p>
    </div>
  );
};

export default EmployeeSelector;
